let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hdq8d")).then(() => parcelRequire('hP3MQ'));